import React from 'react';
import type { BapAd } from '../../../types';
import { SearchAdHeading, type SearchAdHeadingProps } from '../SearchAdHeading';

type BapHeadingProps = {
    ad: BapAd;
    className?: string;
    heading?: (props: SearchAdHeadingProps) => React.ReactElement | null;
    showSingleLine?: boolean;
};

export function BapHeading(props: BapHeadingProps) {
    const { ad, className = '', heading, showSingleLine = false } = props;

    const headingText = ad.heading || '\u00A0';
    const headingProps: SearchAdHeadingProps = {};

    if (showSingleLine) {
        // Ad header will be shown on a single line, and use additional
        // truncation for long words.
        headingProps.className = `${className} line-clamp-1 whitespace-nowrap`;
        headingProps.linkClass = 'block overflow-hidden text-ellipsis';
    } else {
        // Ad header is shown over two lines, and additional vertical space is
        // added for short titles.
        headingProps.className = `${className} line-clamp-2 min-h-[36]`;
    }

    return heading ? (
        heading(headingProps)
    ) : (
        <SearchAdHeading {...headingProps}>{headingText}</SearchAdHeading>
    );
}
